// @flow

/**
 * LoadingIndicator.js - компонент ссылки назад
 * @module components/LoadingIndicator
 * */

import React from 'react'

import './LoadingIndicator.css'

/**
 * @namespace
 * */
export const LoadingIndicator = () => {
    /**
     * Отрисовка компонента при изменении состояния
     * @memberof LoadingIndicator
     * @alias render
     * */
    return (
    <div className="LoadingIndicator">
        <div className="LoadingIndicator__wrapper">
            <i className="LoadingIndicator__item"></i>
            <i className="LoadingIndicator__item"></i>
            <i className="LoadingIndicator__item"></i>
        </div>
    </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/LoadingIndicator.js